import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import InstaServiceProductionCategory from './InstaServiceProductionCategory';

const base = 'live-dispatch';

@inject('ProductionStore')
@observer
class InstaServiceProduction extends Component {
    render() {
        const { instaServiceProductions } = this.props;

        const groupedByLocation = instaServiceProductions.reduce((acc, stock) => {
            stock.requests.forEach((request) => {
                if (request.status === 'COMPLETED') {
                    return;
                }

                const rawLocation = (request.insta_service_location || 'Warmer').trim();
                const normalizedLocation = rawLocation
                    .toLowerCase()
                    .replace(/\s+/g, ' ')
                    .replace(/\b\w/g, (char) => char.toUpperCase());

                if (!acc[normalizedLocation]) {
                    acc[normalizedLocation] = [];
                }

                acc[normalizedLocation].push({
                    ...request,
                    id: stock.id,
                    created_date: stock.created_date,
                });
            });

            return acc;
        }, {});

        const allLocations = Object.keys(groupedByLocation);
        const fixedOrder = ['Warmer', 'Sous Vide', 'Chiller', 'Ambient'];
        const otherLocations = allLocations.filter((location) => !fixedOrder.includes(location));
        const locations = [...fixedOrder, ...otherLocations.sort()];

        const groupedData = locations.map((location) => {
            const requests = groupedByLocation[location] || [];
            const groupedByCategory = requests.reduce((acc, request) => {
                const { category } = request;

                if (!acc[category]) {
                    acc[category] = {
                        id: request.id,
                        items: [],
                        created_date: request.created_date,
                    };
                }

                acc[category].items.push(request);

                if (new Date(request.created_date) < new Date(acc[category].created_date)) {
                    acc[category].created_date = request.created_date;
                }

                return acc;
            }, {});

            const categories = Object.keys(groupedByCategory)
                .map((category) => ({
                    id: groupedByCategory[category].id,
                    category,
                    created_date: groupedByCategory[category].created_date,
                    items: groupedByCategory[category].items.sort((a, b) => b.quantity - a.quantity),
                }))
                .sort((a, b) => b.items.length - a.items.length);

            return { location, categories };
        });

        return (
            <div>
                <div
                    className={`${base}__card_header top-up`}
                >
                    <div
                        className='top-up'
                    >
                        InstaService Top Up
                    </div>
                </div>
                <div className={`${base}__insta_service_panel_body`}>
                    {groupedData
                        .filter(({ categories }) => categories.length > 0)
                        .map(({ location, categories }) => (
                            <div key={location} className={`${base}__insta_service_location_section`}>
                                <h4 className={`${base}__insta_service_location_title`}>
                                    {`IN ${location.toUpperCase()}`}
                                </h4>
                                {categories.map((category) => (
                                    <InstaServiceProductionCategory
                                        category={category}
                                        key={`${location}-${category.category}`}
                                        isCurrentStock={false}
                                    />
                                ))}
                            </div>
                        ))}
                </div>
            </div>
        );
    }
}

export default InstaServiceProduction;
